import { useQuery } from '@tanstack/react-query';
import { getClinicMasterProduct } from '../requests';
import { ExistingClinicMasterProduct } from '../types';

interface UseClinicMasterProductReturn {
  clinicMasterProduct?: ExistingClinicMasterProduct | null;
  isLoading: boolean;
}

const useClinicMasterProduct = (id: string): UseClinicMasterProductReturn => {
  const isEnabled = id !== 'create';

  const { data, isLoading } = useQuery({
    queryFn: () => getClinicMasterProduct(id),
    queryKey: ['clinic-master-product', id],
    enabled: isEnabled,
  });

  const clinicMasterProduct = data?.data.data;
  const isArray = Array.isArray(clinicMasterProduct);

  return {
    clinicMasterProduct: clinicMasterProduct && !isArray ? clinicMasterProduct  : null,
    isLoading: isEnabled && isLoading,
  };
};

export default useClinicMasterProduct;
